module.exports = __webpack_public_path__ + "img/security.3ef7892a.svg";